import { useEffect } from "react";
import { useInfiniteQuery, useQueryClient } from "react-query";
import { fetchPatientEncounters } from "@/services/encounters";
/**
 * Infinite-query hook paging through a patient's encounters with optional filters.
 * Cached pages are dropped on unmount so revisiting the panel starts fresh from
 * page one instead of refetching every previously loaded page at once.
 */
export function usePatientEncountersInfinite(workspaceId, patientId, filters) {
  var queryClient = useQueryClient();
  var query = useInfiniteQuery(["patient-encounters-infinite", workspaceId, patientId, filters !== null && filters !== void 0 ? filters : {}], function (_ref) {
    var _ref$pageParam = _ref.pageParam,
      pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
    return fetchPatientEncounters(workspaceId, patientId, pageParam, filters);
  }, {
    enabled: Boolean(workspaceId && patientId),
    keepPreviousData: true,
    getNextPageParam: function getNextPageParam(lastPage) {
      var _lastPage$page;
      return lastPage.has_next ? ((_lastPage$page = lastPage.page) !== null && _lastPage$page !== void 0 ? _lastPage$page : 1) + 1 : undefined;
    }
  });
  useEffect(function () {
    return function () {
      queryClient.removeQueries(["patient-encounters-infinite", workspaceId, patientId]);
    };
  }, [queryClient, workspaceId, patientId]);
  return query;
}